import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { UtilService } from '../services/util.service';
import { ErrorLogService } from '../services/error-log.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		@Inject(PLATFORM_ID) public platformId: Object,
		public authService : AuthService,
		public utilService : UtilService,
		public errorLog: ErrorLogService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {
			this.errorLog.handleError(new Error(JSON.stringify({response:err,request})), 'http');	
			if(!request.url.includes(environment.apiURL)){
				return throwError(err);
			}		
			if ([401, 403].indexOf(err.status) !== -1) {
				let errorMsg = typeof err.error == 'string' ? err.error : err.message
				this.utilService.openSnackBar(errorMsg || 'Unauthorized');
				// auto logout if 401 Unauthorized or 403 Forbidden response returned from api
				if(!request.url.includes('auth')){
					// this.authService.logout();
				}
			}else if(!request.url.includes('cert-wiz') && !request.url.includes('userlookup') && !request.url.includes('demographics')){
				// Status 0 indicates a network-level failure (offline, DNS, CORS preflight,
				// server unreachable). Substitute a friendly message instead of Angular's
				// default "Http failure response for ...: 0 Unknown Error".
				const msg = err.status === 0
					? 'Unable to reach the server. Please check your connection and try again.'
					: (typeof err.error == 'string' ? err.error : err.message);
				if (msg && msg.includes('\n')) {
					// Multi-line errors (e.g., ALSDE Demographics 400 with bulleted list of
					// missing sections) render better in a dialog than a snackbar.
					this.utilService.openMsgDialog(msg.replace(/\n/g, '<br>'), 'Unable to Continue');
				} else {
					this.utilService.openSnackBar(msg);
				}
			}
			return throwError(err);
		}))
	}
}